<template>
  <div class="app-main__inner">
    <TituloComponent icono-titulo="fas fa-pencil-alt" texto-titulo="Ver datos personales"></TituloComponent>
    <div class="tab-pane tabs-animation fade show active" id="tab-content-0" role="tabpanel">
      <div class="row">
        <div class="col-lg-12 mb-4">
          <div class="main-card mb-3 card">
            <div class="card-body divPersona">
              <h5 class="border-bottom">
                <i class="fas fa-user btn-icon-wrapper btn-icon-sm mb-2"></i> Datos personales
              </h5>
              <div class="widget-content">
                <div class="widget-content-wrapper row">
                  <div class="widget-content-left col-12">
                    <h5
                      class="widget-heading text-alternate"
                    >{{ persona.nombre }} {{ persona.apellido }}</h5>
                    <div class="widget-subheading opacity-10 row">
                      <span class="col-sm-auto col-12 text-alternate">
                        Doc. Tipo
                        <b>{{ persona.tipo_documento }}</b>
                      </span>
                      <span class="col-sm-auto col-12 text-alternate">
                        N°. Doc.
                        <b>{{ persona.dni }}</b>
                      </span>
                      <span class="col-sm-auto col-12 text-alternate">
                        N°. Cuil
                        <b>{{ persona.cuil }}</b>
                      </span>
                      <span class="col-sm-auto col-12 text-alternate">
                        N°. Afiliado:
                        <b>{{ persona.numero_afiliado }}</b>
                      </span>
                      <span class="col-sm-auto col-12 text-alternate">
                        Fecha Nacimiento
                        <b>{{ persona.fecha_nacimiento }}</b>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="main-card mb-3 card">
            <div class="card-body">
              <h5 class="border-bottom">
                <i class="fas fa-map-marker-alt btn-icon-wrapper btn-icon-sm mb-2"></i> Datos Ubicación
              </h5>
              <div class="row pt-3">
                <div class="col-lg-4">
                  <h5 class="text-primary">Nacionalidad</h5>
                  <p>{{ persona.nacionalidad }}</p>
                </div>
                <div class="col-lg-4">
                  <h5 class="widget-heading text-primary">Provincia</h5>
                  <p>{{ persona.provincia }}</p>
                </div>
                <div class="col-lg-4">
                  <h5 class="text-primary">Localidad</h5>
                  <p>{{ persona.localidad }}</p>
                </div>
                <div class="col-lg-4">
                  <h5 class="text-primary">Domicilio</h5>
                  <p>{{ persona.domicilio }}</p>
                </div>
                <div class="col-lg-4">
                  <h5 class="text-primary">Depto</h5>
                  <p v-if="persona.depto">{{ persona.depto }}</p>
                  <p v-else>Sin Informar</p>
                </div>
                <div class="col-lg-4">
                  <h5 class="text-primary">Piso</h5>
                  <p v-if="persona.piso">{{ persona.piso }}</p>
                  <p v-else>Sin Informar</p>
                </div>
                <div class="col-lg-4">
                  <h5 class="text-primary">Cod. postal</h5>
                  <p>{{ persona.codigo_postal }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="main-card mb-3 card">
            <div class="card-body">
              <h5 class="border-bottom">
                <i class="metismenu-icon fas fa-file-alt btn-icon-wrapper btn-icon-sm mb-2"></i> Otros
              </h5>
              <div class="row pt-3">
                <div class="col-lg-3">
                  <h5 class="text-success">Email</h5>
                  <p v-if="persona.email">{{ persona.email }}</p>
                  <p v-else>Sin Informar</p>
                </div>
                <div class="col-lg-3">
                  <h5 class="text-success">Teléfono</h5>
                  <p v-if="persona.telefono">{{ persona.telefono }}</p>
                  <p v-else>Sin Informar</p>
                </div>
                <div class="col-lg-3">
                  <h5 class="text-success">Antigüedad</h5>
                  <p v-if="persona.antiguedad">{{ persona.antiguedad }}</p>
                  <p v-else>Sin Informar</p>
                </div>
                <div class="col-lg-3">
                  <h5 class="text-success">Estado Civil</h5>
                  <p v-if="persona.estado_civil">{{ persona.estado_civil }}</p>
                  <p v-else>Sin Informar</p>
                </div>
                <div class="col-lg-3">
                  <h5 class="text-success">Sexo</h5>
                  <p v-if="persona.sexo">{{ persona.sexo }}</p>
                  <p v-else>Sin Informar</p>
                </div>
              </div>
            </div>
          </div>
          <div class="main-card mb-3 card">
            <div class="card-body">
              <h5 class="border-bottom">
                <i class="metismenu-icon fas fa-file-alt btn-icon-wrapper btn-icon-sm mb-2"></i> Datos afip
              </h5>
              <div class="row pt-3">
                <div class="col-lg-3">
                  <h5 class="text-success">Código de actividad</h5>
                  <p v-if="persona.datos_afip.length">{{ persona.datos_afip[0].codigo_actividad }}</p>
                  <p v-else>Sin Informar</p>
                </div>
                <div class="col-lg-3">
                  <h5 class="text-success">Cantidad de adherentes</h5>
                  <p v-if="persona.datos_afip.length">{{ persona.datos_afip[0].cantidad_adherentes }}</p>
                  <p v-else>Sin Informar</p>
                </div>
                <div class="col-lg-3">
                  <h5 class="text-success">Codigo obra social</h5>
                  <p v-if="persona.datos_afip.length">{{ persona.datos_afip[0].codigo_obra_social }}</p>
                  <p v-else>Sin Informar</p>
                </div>
                <div class="col-lg-3">
                  <h5 class="text-success">Código modalidad contratación</h5>
                  <p v-if="persona.datos_afip.length">{{ persona.datos_afip[0].codigo_modalidad_contratacion }}</p>
                  <p v-else>Sin Informar</p>
                </div>
                <div class="col-lg-3">
                  <h5 class="text-success">Código de zona</h5>
                  <p v-if="persona.datos_afip.length">{{ persona.datos_afip[0].codigo_zona }}</p>
                  <p v-else>Sin Informar</p>
                </div>
                <div class="col-lg-3">
                  <h5 class="text-success">Corresponde reduccion</h5>
                  <p v-if="persona.datos_afip.length">{{ persona.datos_afip[0].corresponde_reduccion }}</p>
                  <p v-else>Sin Informar</p>
                </div>
                <div class="col-lg-3">
                  <h5 class="text-success">CBU</h5>
                  <p v-if="persona.cbu">{{ persona.cbu }}</p>
                  <p v-else>Sin Informar</p>
                </div>
              </div>
            </div>
          </div>
          <div class="main-card mb-3 card">
            <div class="card-body divPersona">
              <h5 class>
                <i class="fas fa-file-alt btn-icon-wrapper btn-icon-sm mb-2"></i> Legajos
              </h5>
              <ul class="list-group list-group-flush mb-3">
                <li
                  class="list-group-item hoverable"
                  v-for="legajo in persona.legajos"
                  :key="legajo.id"
                  @click="verLegajo(legajo)"
                >
                  <div class="widget-content p-0">
                    <div class="widget-content-wrapper row">
                      <div class="widget-content-left col-12">
                        <h5
                          class="widget-heading text-primary"
                        >{{ legajo.numero }}) {{ legajo.cargo.descripcion }}</h5>
                        <div class="widget-subheading opacity-10 row">
                          <span class="col-sm-auto col-12 text-alternate">
                            Seccion:
                            <b>{{ legajo.seccion.descripcion }}</b>
                          </span>
                          <span class="col-sm-auto col-12 text-focus">
                            Categoría:
                            <b>{{ legajo.categoria.descripcion }}</b>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-12">
            <router-link :to="{name:'EditarPersona', params:{id:persona.id}}">
              <button class="mt-1 btn btn-success float-right">Editar</button>
            </router-link>
            <button @click="eliminarPersona()" class="mt-1 btn btn-danger float-right mr-4">Eliminar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponente";
import axios from "axios";
import Swal from "sweetalert2";
import Persona from "@/models/persona";
import "@/assets/css/chekbox.css";

export default {
  name: "VerPersona",
  components: {
    TituloComponent,
  },
  data() {
    return {
      persona: new Persona(
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null
      ),
      loading: false,
      enviado: false,
      institucion: JSON.parse(localStorage.getItem("institucion")),
    };
  },
  created() {
    this.persona.id = this.$route.params.id;
    this.getPersona();
  },
  mounted() {
  },
  methods: {
    getPersona() {
      this.loading = true;
      axios
        .get("personas/" + this.persona.id)
        .then((res) => {
          if (res.data.success) {
            console.log(res.data);
            this.persona = res.data.persona;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "Oopss..",
            text: `No se ha encontrado Persona.`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    eliminarPersona() {
      Swal.fire({
        title: "¿Estás seguro?",
        text: `¿Deseas eliminar a ${this.persona.nombre} ${this.persona.apellido} de manera permanente?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          axios
            .delete("personas/" + this.persona.id)
            .then((res) => {
              Swal.fire(
                "Eliminado",
                `${res.data.persona.numero} se ha eliminado con éxito.`,
                "success"
              );
              console.log(this.$refs);
              this.$router.push({name: "ListarPersonas"});
            })
            .catch((err) => console.log(err))
            .finally(() => (this.loading = false));
        }
      });
    },
    verLegajo(legajo) {
      this.$router.push({name: "VerLegajo", params: {id: legajo.id}});
    },
  },
};
</script>
